function averageBody(candles, lastIndex) {
  const start = Math.max(0, lastIndex - 20);
  const sample = candles.slice(start, lastIndex);
  return sample.reduce((total, candle) => total + Math.abs(candle.close - candle.open), 0) / Math.max(sample.length, 1);
}

export function valueAtTrendLine(trendLine, time) {
  const [start, end] = trendLine.points;
  if (!start || !end || end.time === start.time) return end?.value ?? null;
  return start.value + ((end.value - start.value) / (end.time - start.time)) * (time - start.time);
}

export function isSpikeCandle(candles, index) {
  const candle = candles[index];
  if (!candle) return false;
  const body = Math.abs(candle.close - candle.open);
  const range = candle.high - candle.low;
  return range > 0 && body / range >= 0.6 && body >= averageBody(candles, index) * 1.5;
}

export function detectValidBreakout(trendLine, candles) {
  const index = candles.length - 1;
  const candle = candles[index];
  if (!trendLine || !candle || candle.isClosed === false || !isSpikeCandle(candles, index)) return null;
  const lineValue = valueAtTrendLine(trendLine, candle.time);
  if (!Number.isFinite(lineValue)) return null;

  const bodyAbove = Math.min(candle.open, candle.close) > lineValue;
  const bodyBelow = Math.max(candle.open, candle.close) < lineValue;
  const valid = trendLine.direction === "DOWN" ? candle.close > lineValue && bodyAbove : candle.close < lineValue && bodyBelow;
  return valid ? { time: candle.time, direction: trendLine.direction === "DOWN" ? "UP" : "DOWN", candle, lineValue } : null;
}
